<h1 class="pr-tt">Qué querés recibir</h1>
<p class="pr-sub">Elegí qué te mandamos y por dónde.</p>

<loading-indicator *ngIf="isLoading"></loading-indicator>

<ng-container *ngIf="!isLoading">

  <section class="mc-blk">
    <div class="mc-hd"><h2>Qué querés recibir</h2></div>
    <div class="pr-card">
      <button type="button" class="pr-opt" *ngFor="let o of queRecibir"
              [class.on]="o.activo" (click)="alternar(o)">
        <span class="pr-box"></span>
        <span class="pr-ct">
          <b>{{ o.titulo }}</b>
          <span>{{ o.detalle }}</span>
        </span>
      </button>
    </div>
  </section>

  <section class="mc-blk">
    <div class="mc-hd"><h2>Por dónde</h2></div>
    <div class="pr-card">
      <button type="button" class="pr-opt" *ngFor="let o of porDonde"
              [class.on]="o.activo" (click)="alternar(o)">
        <span class="pr-box"></span>
        <span class="pr-ct">
          <b>{{ o.titulo }}</b>
          <span *ngIf="o.detalle">{{ o.detalle }}</span>
        </span>
      </button>
    </div>
  </section>

  <!-- Honesto: los interruptores todavia no guardan nada. Ver el componente. -->
  <p class="pr-aviso">
    Estás viendo cómo va a funcionar esta sección. Todavía no estamos guardando
    los cambios; muy pronto vas a poder elegir de verdad qué te mandamos.
  </p>

</ng-container>
